import i18next from 'i18next';
import * as Yup from 'yup';

import { RequisitesCascadeMode } from 'enums';

export const SCI_CUSTOMER_ALTERNATIVES_MAX_TIMEOUT = 60;
export const SCI_CUSTOMER_ALTERNATIVES_MAX_ATTEMPTS = 10;
export const MAX_PARALLEL_CUSTOMER_ORDERS_LIMIT = 10;
export const SHOP_WEBHOOK_AMOUNT_OFFSET_MAX = 100000;
export const PAYIN_PARALLEL_PRIORITY_TIMEOUT_DEFAULT_SEC = 5;
// in the shop asset currency, same default as the backend
export const NEGATIVE_PROFIT_DAILY_LOSS_LIMIT_DEFAULT = 3000;

export const NEGATIVE_PROFIT_VALIDATION_SCHEMA = {
  negativeProfitAllowed: Yup.boolean(),
  negativeProfitDailyLossLimit: Yup.number().when('negativeProfitAllowed', {
    is: true,
    then: (schema) =>
      schema
        .required(i18next.t('errors.required'))
        .moreThan(0, i18next.t('errors.natural_number')),
    otherwise: (schema) => schema.nullable(),
  }),
};

export const PAYIN_CASCADE_RETRY_CYCLES_MIN = 1;
export const PAYIN_CASCADE_RETRY_CYCLES_MAX = 10;
export const PAYIN_CASCADE_RETRY_CYCLES_DEFAULT = 1;
export const PAYIN_CASCADE_RETRY_MODES: RequisitesCascadeMode[] = [
  RequisitesCascadeMode.ProvidersOnly,
  RequisitesCascadeMode.Parallel,
  RequisitesCascadeMode.ParallelPriority,
];

export const SCI_CUSTOMER_ALTERNATIVES_VALIDATION_SCHEMA = Yup.object().shape({
  alternativeAmountEnabled: Yup.boolean().required(
    i18next.t('errors.required'),
  ),
  alternativeTradeMethodEnabled: Yup.boolean().required(
    i18next.t('errors.required'),
  ),
  timeout: Yup.number()
    .nullable()
    .min(1, i18next.t('errors.natural_number'))
    .max(
      SCI_CUSTOMER_ALTERNATIVES_MAX_TIMEOUT,
      `${i18next.t('errors.max')} ${SCI_CUSTOMER_ALTERNATIVES_MAX_TIMEOUT}`,
    )
    .when(['alternativeAmountEnabled', 'alternativeTradeMethodEnabled'], {
      is: (
        alternativeAmountEnabled: boolean,
        alternativeTradeMethodEnabled: boolean,
      ) => alternativeAmountEnabled || alternativeTradeMethodEnabled,
      then: (schema) => schema.required(i18next.t('errors.required')),
      otherwise: (schema) => schema.optional().nullable(),
    }),
  maxAttempts: Yup.number()
    .nullable()
    .min(1, i18next.t('errors.natural_number'))
    .max(
      SCI_CUSTOMER_ALTERNATIVES_MAX_ATTEMPTS,
      `${i18next.t('errors.max')} ${SCI_CUSTOMER_ALTERNATIVES_MAX_ATTEMPTS}`,
    )
    .when(['alternativeAmountEnabled', 'alternativeTradeMethodEnabled'], {
      is: (
        alternativeAmountEnabled: boolean,
        alternativeTradeMethodEnabled: boolean,
      ) => alternativeAmountEnabled || alternativeTradeMethodEnabled,
      then: (schema) => schema.required(i18next.t('errors.required')),
      otherwise: (schema) => schema.optional().nullable(),
    }),
});
